import { APIs } from "../../../../../../../util/api/APIs";
import SafeairManager from "../../../../../../../util/api/SafeairManager";
import { OrganizationType } from "../types/OrganizationType";

class CreateFlightService {
  async addOrganization(name: string) {
    const response = await SafeairManager.invoke({
      api: APIs.Organization.CreateOrganization,
      parameters: null,
      body: {
        name,
      },
    });
    return response;
  }

  async getOrganizations() {
    const response = await SafeairManager.invoke({
      api: APIs.Organization.ListAllOrganizations,
      parameters: null,
      body: {},
    });
    return response.data as OrganizationType[];
  }
  
  async getOrgByUserName(name: string) {
    const response = await SafeairManager.invoke({
      api: APIs.Organization.OrgByUserName,
      parameters: {
        username: name
      },
      body: {},
    });
    return response.data;
  }

  async updateOrganizations(name: string, orgId: string) {
    const response = await SafeairManager.invoke({
      api: APIs.Organization.updateOrg,
      parameters: {
        username: name,
        "organization-id": orgId
      },
      body: {},
    });
    return response.data;
  }

  async addFlight( organizationId: string, msn : string,fleetType: string,wifiProvider : string,tailNumber:string)  {
    const response = await SafeairManager.invoke({
      api: APIs.Flight.CreateFlight,
      parameters: null,
      body: {
        id:tailNumber,
        organizationId: organizationId,
        msn:msn,
        fleetType:fleetType,
        wifiProvider:wifiProvider,
        tailNumber:tailNumber,
        departurePlace: "PHX",
        arrivalPlace: null,
        diversionDecisionStatus: "DIVERSION_NOT_REQUIRED",
        schedDepTime: "2020-01-01T08:00:00+0000",
        schedArvTime: "2055-01-01T11:00:00+0000",
        actualDepTime: "2020-01-01T08:30:00+0000",
        actualArvTime: "2055-01-01T11:30:00+0000",
        },
    });
    return response.data as OrganizationType[];
  }
  async updateFlight(id: string, msn : number,tailNumber:number,fleetType: string,wifiProvider : string,organizationId: string)  {
    const response = await SafeairManager.invoke({
      api: APIs.Flight.UpdateFlight,
      parameters: null,
      body: {
        id:id,
        // departurePlace: "",
        // arrivalPlace : "",
        // diversionDecisionStatus: "DIVERSION_NOT_REQUIRED",
        organizationId: organizationId,
        // schedDepTime: schedDepTime,
        // schedArvTime: schedArvTime,
        // actualDepTime: actualDepTime,
        // actualArvTime: actualArvTime,
        msn:msn,
        fleetType:fleetType,
        wifiProvider:wifiProvider,
        tailNumber:tailNumber
        
        // schedDepTime: "2020-01-01T08:00:00+0000",
        // schedArvTime: "2055-01-01T11:00:00+0000",
        // actualDepTime: "2020-01-01T08:30:00+0000",
        // actualArvTime: "2055-01-01T11:30:00+0000",
      },
    });
    return response.data as OrganizationType[];
  }

  async getOrganization(orgId: string) {

    const response = await SafeairManager.invoke({
      api: APIs.Organization.getOrganizationById,
      parameters: {
        "organization-id": orgId
      },
      body: {},
    });
    return response.data
  }
  // async updateOrganization(orgId: string,name : string,address : string, phoneNumber : number,email:string) {
  //   alert(orgId)
  //   const response = await SafeairManager.invoke({
  //     api: APIs.Organization.updateOrganizationById,
  //     parameters: {
  //       "organization-id": orgId,
  //       "name": name,
  //       "address": address,
  //       "phoneNumber" : phoneNumber,
  //       "email":email


  //     },
  //     body: {},
  //   });
  //   return response.data
  // }
}

export default new CreateFlightService();
